export default __webpack_public_path__ + "static/media/logo_no_text_black.ae78ccc5.png";